import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web/common/pete/types';

export const eventKey = 'cart-abandoned_brand_cart_nudge_viewed-view';

/**
 * This event gets triggered when the user views the abandoned cart brand nudge on Web
 */
export function trackCartAbandonedBrandCartNudgeViewedView(
  NudgeType_string: string,
  PageName_string2: string,
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    manualOverrides,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { NudgeType_string, PageName_string2 },
  });
}
